<template>
    <div
        class="overflow-hidden bg-white border border-gray-200 rounded-lg"
        :class="cardClass"
    >
        <div class="flex items-start justify-between gap-3">
            <div
                class="flex-1 min-w-0 text-xs font-medium text-gray-700 [&_h1]:mb-0 [&_h1]:text-xs [&_h1]:font-medium [&_h2]:mb-0 [&_h2]:text-xs [&_h2]:font-medium [&_h3]:mb-0 [&_h3]:text-xs [&_h3]:font-medium [&_h4]:mb-0 [&_h4]:text-xs [&_h4]:font-medium [&_h5]:mb-0 [&_h5]:text-xs [&_h5]:font-medium [&_h6]:mb-0 [&_h6]:text-xs [&_h6]:font-medium"
            >
                <slot name="header"></slot>
            </div>

            <button
                type="button"
                class="inline-flex items-center justify-center flex-shrink-0 w-7 h-7 -mt-1 -mr-1 text-gray-500 transition-colors border border-gray-200 rounded-md hover:bg-gray-50 hover:text-gray-700 focus:outline-none focus:ring-1 focus:ring-gray-300"
                :aria-label="collapsed ? 'Expand section' : 'Collapse section'"
                :aria-expanded="(!collapsed).toString()"
                :title="collapsed ? 'Expand section' : 'Collapse section'"
                v-on:click="collapseExpand"
            >
                <ChevronDownIcon v-if="collapsed" class="w-4 h-4" />
                <MinusSmIcon v-if="!collapsed" class="w-4 h-4" />
            </button>
        </div>

        <div
            v-if="$slots.preview"
            class="mt-2 overflow-hidden text-xs text-gray-500"
            :class="collapsed ? '' : hiddenClass"
        >
            <slot name="preview"></slot>
        </div>

        <div
            v-if="$slots.body"
            class="mt-2 overflow-hidden text-xs text-gray-700"
            :class="!collapsed ? '' : hiddenClass"
        >
            <slot name="body"></slot>
        </div>
    </div>
</template>
<script>
import { ChevronDownIcon, MinusSmIcon } from '@heroicons/vue/solid';

export default {
    components: { MinusSmIcon, ChevronDownIcon },
    props: {
        compact: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            collapsed: true,
        };
    },
    methods: {
        collapseExpand() {
            this.collapsed = !this.collapsed;
        },
    },
    computed: {
        hiddenClass() {
            return 'max-h-0 focus-within:max-h-full';
        },
        cardClass() {
            return this.compact ? 'p-3' : 'p-4';
        },
    },
};
</script>
